import React from 'react';

import { FormControlLabel, Radio, Typography } from '@mui/material';

import {
	ThemeBackgroundImageItemLabelInnerWrap,
	ThemeBackgroundImageItemLabelWrap,
	ThemeBackgroundImageItemWrap,
} from './styled';

interface PropsType {
	value: string;
	label?: any;
	labelBg: string;
	labelText: string;
}

function ThemeBackgroundImageItem({ label, labelText, labelBg, value }: PropsType) {
	return (
		<FormControlLabel
			control={<Radio size="small" />}
			value={value}
			labelPlacement="top"
			sx={{
				flex: 1,
				'& .MuiFormControlLabel-label': {
					width: '100%',
				},
			}}
			label={
				<ThemeBackgroundImageItemWrap>
					<ThemeBackgroundImageItemLabelWrap>
						<ThemeBackgroundImageItemLabelInnerWrap labelBg={labelBg}>
							{label}
						</ThemeBackgroundImageItemLabelInnerWrap>
					</ThemeBackgroundImageItemLabelWrap>
					<Typography sx={{ width: '100%' }}>{labelText}</Typography>
				</ThemeBackgroundImageItemWrap>
			}
		/>
	);
}

export default ThemeBackgroundImageItem;
